import PopupConvertToType2 from './PopupConvertToType2';

export default PopupConvertToType2;
